import * as React from "react";
import { toINR } from "../../../../service/numberFormat";
import OverflowButton from "../../../../generic/overflowButton";
import { IListObj } from "../../../../types/genericTypes";

export interface IHoldMfUsableRowDskProps {
  rowData: any;
}

const overflowBtnDropdownOptions: Array<IListObj> = [
  { value: "buy", display: "Buy" },
  { value: "sell", display: "Sell" },
];

const HoldMfUsableRowDsk: React.FC<IHoldMfUsableRowDskProps> = (props) => {
  return (
    <li className="data_row">
      <div className="col scName robotoM">
        <span dangerouslySetInnerHTML={{ __html: props.rowData.scName }}></span>
      </div>
      <div className="col ct">{props.rowData.ct}</div>
      <div className="col mode">{props.rowData.mode}</div>
      <div className="col qty w_80">
        {toINR(props.rowData.hdgQty)}
        <br />
        <span className="usdQty">{toINR(props.rowData.usdQty)}</span>
      </div>
      <div className="col nav w_80">{toINR(props.rowData.nav)}</div>
      <div className="col amount w_90">{toINR(props.rowData.amount)}</div>
      <div className="col overflowBtn">
        <OverflowButton
          dropdownOptions={overflowBtnDropdownOptions}
          onSelect={(id, data) => {
            //console.log(id, data);
          }}
          showBuySellColor
        />
      </div>
    </li>
  );
};

export default HoldMfUsableRowDsk;
